import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetOrdersByUidQuery } from '../../../features/api/apiSlice';
import Order from './Order';

const Orders = () => {
    const { userInfo } = useSelector(state => state.user);
    const uid = userInfo?.uid;
    const { data: orders, isLoading, isError } = useGetOrdersByUidQuery(uid, { skip: !uid });
  
    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    let content = null;
    if (isLoading) {
        content = <h3 className='bg-white py-5 px-2 shadow text-center'>{translate ? "Loading..." : "লোড হচ্ছে..."}</h3>
    }
    if (!isLoading && isError) {
        content = <h1 className='bg-white py-5 px-2 shadow text-center'>{translate ? "There was an error" : " এখানে একটি ত্রুটি হয়েছে "}</h1>
    }
    if (!isLoading && !isError && orders?.length === 0) {
        content = <h1 className='bg-white py-5 px-2 shadow text-center'>{translate ? "No products found!" : "আপনার কোনো প্রডাক্ট পওয়া যায়নি।"}</h1>
    }
    if (!isLoading && !isError && orders?.length > 0) {
        content = orders.map((order, index) => <Order key={index} order={order} />)
    }
    
    return (
        <div className='bg-gray-50'>
            <div className="container py-4">
                <div className="md:flex gap-10 md:pb-[20px]">
                    <h3 className="md:text-5xl text-xl font-poppins">{translate ? "My Orders" : "আমার অডার গুলো"}</h3>
                    {translate ? 
                       <p className="font-medium text-gray-400 font-poppins">View and edit all your pending delivered. <br /> and returned orders here</p>
                    : 
                    <p className="font-medium text-gray-400 font-poppins">আপনার সমস্ত অডার বিতরণ দেখুন এবং সম্পাদনা করুন. <br /> এবং এখানে অডার ফেরত</p>
                    }
                </div>
                <div className="">
                    {content}
                </div>
            </div>
        </div>
    );
};

export default Orders;